import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/iconPlaybackRate1_2x.svg'

export const IconPlaybackRate1_2x = IconSVG as IconComponent
